import { ApiEndpoints } from "@shared/api/api-endpoints";
import { onboardingApiClient } from "@shared/api/clients/apiClientFactory";
import { transformJsonToObject } from "@shared/utils/jsonToObjectTransformer";
import { RateDetail, RateTypeOption, TariffListItem, tarrifFilters, UtilityServiceOption } from "./types";


export const PlanRatesApi = {
  getRecentlyUpdatedPlans: async (
    remoteUtilityId: string,
    limit = 3
  ): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "recently-updated/plan",
      (query: any) => {
        query.push("remote_utility_id", remoteUtilityId);
        query.push("page", "1");
        query.push("limit", limit.toString());
      }
    );
    const response = await onboardingApiClient.get(url);
    return transformJsonToObject(response.data);
  },

  getRecentlyUpdatedRates: async (
    remoteUtilityId: string,
    limit = 3
  ): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "recently-updated/rate",
      (query: any) => {
        query.push("remote_utility_id", remoteUtilityId);
        query.push("page", "1");
        query.push("limit", limit.toString());
      }
    );
    const response = await onboardingApiClient.get(url);
    return transformJsonToObject(response.data);
  },

  getPlanDashboardData: async (
    remoteUtilityId: string
  ): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "plan/dashboard",
      (query: any) => {
        query.push("remote_utility_id", remoteUtilityId);
      }
    );
    const response = await onboardingApiClient.get(url);
    return transformJsonToObject(response.data.result);
  },

  getUtilityServices: async (
      remoteUtilityId: string
    ): Promise<UtilityServiceOption[]> => {
      const url = ApiEndpoints.createUrlWithQueryParameters(
        "auth",
        "utility/services",
        (query) => {
          query.push("remote_utility_id", remoteUtilityId);
        }
      );
      const response = await onboardingApiClient.get(url);
  
      const data = response.data?.result;
      return data
        .filter((item: any) => item.isActive)
        .map((item: any) => ({
          id: item.name,
          name: item.name,
          code: item.code || item.name,
          isActive: item.isActive,
          unit:item.utilityUnit,
        }));
    },

    getTarrifList: async (
        remoteUtilityId: string,
        filters: tarrifFilters = {}
      ): Promise<TariffListItem> => {
        console.log("filters", filters);
        const url = ApiEndpoints.createUrlWithQueryParameters(
          "onboarding",
          "rate-v1",
          (query) => {
            query.push("remote_utility_id", remoteUtilityId);
            query.push("page", (filters.page || 1).toString());
            query.push("limit", (filters.limit || 50).toString());
    
            if (filters.search_data) query.push("search_data", filters.search_data);
            if (filters.utilityService) {
              query.push("utility_service", filters.utilityService);
            }
            if (filters.createdBy) {
              query.push("created_by", filters.createdBy);
            }
    
            if (filters.rateType) {
              query.push("rate_type", filters.rateType);
            }
            if (filters.status?.length) {
              filters.status.forEach((status) =>
                query.push("status", status.toString())
              );
            }
          }
        );
        const response = await onboardingApiClient.get(url);
        return response.data;
      },

    updateRate: async (data: any, id: number): Promise<any> => {
      const url = ApiEndpoints.createUrlWithPathVariables(
        "onboarding",
        `rate-v1/${id}`
      );
      const response = await onboardingApiClient.put(url, data);
      return response.data;
    },

    cloneRate: async (id: number): Promise<any> => {
      const url = ApiEndpoints.createUrlWithPathVariables(
        "onboarding",
        `rate-v1/${id}/clone`
      );
      const response = await onboardingApiClient.post(url);
      return response.data;
    },

    addRate: async (data: any): Promise<any> => {
      const url = ApiEndpoints.createUrlWithPathVariables(
        "onboarding",
        `rate-v1`
      );
      const response = await onboardingApiClient.post(url, data);
      return response.data;
    },

    getRateTypes: async (): Promise<RateTypeOption[]> => {
      const url = ApiEndpoints.createUrlWithPathVariables(
        "onboarding",
        "choices",
        ["rate_type"]
      );
      const response = await onboardingApiClient.get(url);
      return response.data?.result;
    },

    bulkUpdateRate: async (data: any): Promise<any> => {
      const url = ApiEndpoints.createUrlWithPathVariables(
        "onboarding",
        `rate/bulk-edit`
      );
      const response = await onboardingApiClient.put(url, data);
      return response.data;
    },

    getRateDetail: async (id:string,remoteUtilityId:string): Promise<RateDetail> => {
      const url = ApiEndpoints.createUrlWithPathAndQueryVariables(
        "onboarding",
        `rate-v1`,
        [id,'detail'],
        (query)=>{
          query.push('remote_utility_id',remoteUtilityId)
        }
      );
      const response = await onboardingApiClient.get(url);
      return response.data?.result;
    },

    getVersionDetail: async (id:string): Promise<RateTypeOption[]> => {
      const url = ApiEndpoints.createUrlWithPathAndQueryVariables(
        "onboarding",
        "rate-v1",
        ["versions"],
        (qs)=>{
          qs.push('rate_id',id)
        }
      );
      const response = await onboardingApiClient.get(url);
      return response.data?.results;
    },

     getRateStatus: async (): Promise<RateTypeOption[]> => {
      const url = ApiEndpoints.createUrlWithPathVariables(
        "onboarding",
        "choices",
        ["rate_status"]
      );
      const response = await onboardingApiClient.get(url);
      return response.data?.result;
    },
    
};
